import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';


const RequestOfferSkeleton = () => {

    return (
        <>
            <Skeleton height={45} />
            <Skeleton height={40} />
            <Skeleton height={40} />
            <Skeleton height={40} width="50%" />
        </>
    );
}

export default RequestOfferSkeleton;